module.exports = __webpack_public_path__ + "img/Magnuss03.6b684d8e.jpg";